<template>
    <Breadcrumbs title="User Profile" main="Users" />


    <div class="container-fluid ">
        <div class="user-profile">
            <div class="row">
               

            </div>
        </div>
    </div>
</template>

<script>



export default {
    name: 'userProfile',
    components: {
       
    },

}
</script>
